import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { useTheme } from './hooks/useTheme';
import { Header } from './components/Header/Header';
import { Footer } from './components/Footer/Footer';
import { PageGlow } from './components/PageGlow/PageGlow';
import { Home } from './pages/Home/Home';
import { CategoryPage } from './pages/CategoryPage/CategoryPage';
import { PatternDetail } from './pages/PatternDetail/PatternDetail';
import { Quiz } from './pages/Quiz/Quiz';
import { Glossary } from './pages/Glossary/Glossary';
import { Compare } from './pages/Compare/Compare';
import './styles/global.css';

function App() {
  const { theme, toggle } = useTheme();

  return (
    <BrowserRouter>
      <PageGlow />
      <Header theme={theme} onToggleTheme={toggle} />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/category/:slug" element={<CategoryPage />} />
        <Route path="/pattern/:id" element={<PatternDetail />} />
        <Route path="/quiz" element={<Quiz />} />
        <Route path="/glossary" element={<Glossary />} />
        <Route path="/compare" element={<Compare />} />
      </Routes>
      <Footer />
    </BrowserRouter>
  );
}

export default App;
